import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-nav-menu-item',
    template: `<button mat-button (click)="selected.emit()">{{ label }}</button>`,
    standalone: false
})
export class AppNavMenuItemComponent {
  @Input() label: string;
  @Output() selected = new EventEmitter<void>();
}
